import React, { useState, useEffect, useContext } from 'react'
import _ from 'lodash'
// import { FormBuilder } from 'cb-react-forms'
import { Row, Col, Button } from 'reactstrap'
import LoadingOverlay from "react-loading-overlay"
import { Redirect } from "react-router-dom";
import { useTranslation } from 'react-i18next'

import { UserContext } from "context/auth";

import Alert from "main_views/components/alert"
import { updateForm, setFieldValue, getFieldsValues, showInvalidFields } from '../formHandler'
import { successToast, errorToast } from 'main_views/components/toast'
import { addDoc } from 'dbHandler'
import Form from 'main_views/components/Form/form_v2'
import { generalInfoFields } from '../generalInfoForm'
import { isLangEn, getDir } from 'utils/translation/i18n'

import 'bootstrap/dist/css/bootstrap.css'

function Builder(props) {

    let { FormBuilder } = require('cb-react-forms')
    
    let { t } = useTranslation()

    let { user } = useContext(UserContext)
    let { id, name_en, loggedIn, loading: userAuthLoading } = user

    let [form, setForm] = useState(generalInfoFields)
    let [loading, setLoading] = useState(false)
    let [alert, setAlert] = useState(null)

    let setChanges = (stateName, value, className) => {
        setFieldValue(form, stateName, value, className)
        setForm({ ...form }) // to re-render the form 
    }

    let formValidation = (data) => {

        if (_.isEmpty(form.name.value))
            return errorToast(t('please_set_the_form_name'))

        if (_.isEmpty(form.reminderDays.value))
            return errorToast(t('please_set_the_reminder_days'))

        if (_.isEmpty(_.filter(form.allowFileAttachments.options, opt => opt.checked)))
            return errorToast(t('please_select_the_file_attachments_type'))

        submitAlert(data)
    }

    let submitAlert = (data) =>
        setAlert({
            show: true,
            isWarning: true,
            title: t('add_the_form'),
            msg: t('are_you_sure_you_need_to_add_this_form'),
            confirmBtnText: t('yes_add_it'),
            cancelBtnText: t('cancel'),
            showCancelBtn: true,
            handelCancel: () => setAlert(null),
            handelConfirm: () => {
                setAlert(null)
                submitForm(data)
            },
        })

    let submitForm = async (data) => {

        try {
            setLoading(true)

            data = formJson(data)

            let formInfo = {
                ...getFieldsValues(form).data,
                data,
                createdByStaffId: id,
                createdByStaffName: name_en
            }

            console.log(formInfo);

            await addDoc(formInfo, 'forms')

            successToast(t('form_was_added'))
            goBack()

        } catch (error) {
            console.error("submitForm -> error", { error, data })
            errorToast(t('something_wrong'))

        } finally {
            setLoading(false)
        }

    }

    let goBack = () => window.open('/admin/form-builder') // open in new tab

    if (!userAuthLoading && !loggedIn) return <Redirect to='/auth/login' />

    return (
        <LoadingOverlay active={loading || userAuthLoading} spinner text={t('loading')}>
            <div className='container'>

                <Row className='px-3 py-5'>
                    <Col style={{ textAlignLast: 'end' }}>
                        <Button outline size='sm' className='px-3' onClick={goBack} >{t('back')}</Button>
                        <Button outline size='sm' className='px-3 mx-3' onClick={() => window.location.reload()} >{t('clear')}</Button>
                    </Col>
                </Row>


                <div>
                    <Form
                        inputs={form}
                        onChange={setChanges}
                    />

                    {isLangEn() ?
                        <p className='text-muted' style={{ fontSize: 'small' }}>
                            NOTE: If you need to add a Date input, select the <strong>Text Input</strong> tool then add the word <strong>(date)</strong> at your label
                        <p className='text-muted px-5'>example. Label: Start Date (date)</p>
                        </p>
                        :
                        <p className='text-muted' style={{ fontSize: 'small' }} dir='rtl'>
                            ملاحظة: إذا كنت تريد إضافة حقل إدخال للتاريخ، فأختر أداة <strong>Text Input</strong> ثم أضف كلمة <strong>(date)</strong> في خانة اسم الحقل
                            مثال: تاريخ البدء (date)
                        </p>
                    }

                </div>

                <FormBuilder
                    items={items}
                    onSubmit={formValidation}
                />

                <Alert {...alert} />

            </div>
        </LoadingOverlay>
    )
}

export default Builder

/**
 * convert the form to a json
 * 
 * @param {string} formFields 
 * @returns {object}
 */
function formJson(formFields) {

    let fields = []

    formFields = strToArr(formFields)

    _.forEach(formFields, field => {

        let type = field.element,
            label = field.label ?? ''

        // convert the TextInput to date input (if it's marked as (date))
        if (type === 'TextInput' && typeof label === 'object') {
            try {

                let str = JSON.stringify(label)

                let dateTxtIndex = str.indexOf('(date)')

                if (dateTxtIndex !== -1) { 

                    let newLabel = ''
                    newLabel = str.slice(0, dateTxtIndex)
                    newLabel += JSON.stringify(label).slice(dateTxtIndex + 6)
    
                    type = 'TextInputDate'
                    label = JSON.parse(newLabel)

                }

            } catch (error) {
                console.log("FormField -> error", error)
            }
        }

        fields.push({
            type,
            label,
            stateName: field.id,
            required: field.required ?? false,
            options: field.options ?? []
        })

    })

    return fields

}

function strToArr(str) {

    return JSON.parse(str.replace(/"([a-zA-Z0-9]+?)":/g, '"$1":').replace(/'/g, '"'))
}

const items = [
    {
        key: "Header",
        name: "Header Text",
        icon: "fa fa-header"
    },
    {
        key: "Label",
        name: "Label",
        icon: "fa fa-font"
    },
    {
        key: "Paragraph",
        name: "Paragraph",
        icon: "fa fa-paragraph"
    },
    {
        key: "LineBreak",
        name: "Line Break",
        icon: "fa fa-arrows-h"
    },
    {
        key: "Dropdown",
        name: "Dropdown",
        icon: "fa fa-caret-square-o-down"
    },
    /* {
        key: "Tags",
        name: "Tags",
        icon: "fa fa-tags"
    }, */
    {
        key: "Checkboxes",
        name: "Checkboxes",
        icon: "fa fa-check-square-o"
    },
    {
        key: "RadioButtons",
        name: "Multiple Choice",
        icon: "fa fa-dot-circle-o"
    },
    {
        key: "TextInput",
        name: "Text Input",
        icon: "fa fa-font"
    },
    {
        key: "NumberInput",
        name: "Number Input",
        icon: "fa fa-plus"
    },
    {
        key: "TextArea",
        name: "Multi-line Input",
        icon: "fa fa-text-height"
    },
    /* {
        key: "Rating",
        name: "Rating",
        icon: "fa fa-star"
    },
    {
        key: "HyperLink",
        name: "Web site",
        icon: "fa fa-link"
    },
    {
        key: "Range",
        name: "Range",
        icon: "fa fa-sliders"
    } */
];
